import { Link } from 'react-router-dom';

const navLinks = [
  { label: '계열·진로 탐색', path: '/career-test' },
  { label: '선택과목 추천', path: '/subject-guide' },
  { label: '공부법 검사', path: '/study-style' },
  { label: 'IQ 검사', path: '/iq-test' },
  { label: '어휘력·문해력 검사', path: '/literacy-test' },
];

export default function Footer() {
  return (
    <footer className="bg-primary-50 text-foreground-700 border-t border-background-200 py-12 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-compass-3-line text-white text-sm"></i>
              </div>
              <span className="font-heading font-bold text-foreground-950 text-lg">MC에듀</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              MC교육컨텐츠가 제공하는 교육 진단 플랫폼.
              <br />2022 개정 교육과정 완전 반영.
            </p>
            <div className="mt-4 flex flex-wrap gap-2 text-xs text-foreground-600">
              <span className="bg-white border border-background-200 px-2 py-1 rounded">서울시교육청 자료 기반</span>
              <span className="bg-white border border-background-200 px-2 py-1 rounded">커리어넷 연동</span>
            </div>
          </div>

          {/* Tools */}
          <div>
            <h4 className="text-foreground-950 font-semibold mb-3 text-sm">핵심 도구</h4>
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Data Sources */}
          <div>
            <h4 className="text-foreground-950 font-semibold mb-3 text-sm">자료 출처</h4>
            <ul className="space-y-1.5 text-sm text-foreground-600">
              <li>• 2025학년도 2022개정 교육과정 선택과목 안내서 (서울시교육청)</li>
              <li>• 직업전공 매트릭스 (커리어넷)</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 MC에듀. 교육 진단을 위한 플랫폼입니다.
          </p>
          <div className="flex items-center gap-4 flex-wrap">
            <Link
              to="/terms"
              className="text-xs text-foreground-600 hover:text-foreground-900 transition-colors"
            >
              이용약관
            </Link>
            <Link
              to="/privacy"
              className="text-xs text-foreground-600 hover:text-foreground-900 transition-colors"
            >
              개인정보처리방침
            </Link>
            <Link
              to="/inquiry"
              className="text-xs text-foreground-600 hover:text-foreground-900 transition-colors inline-flex items-center gap-1"
            >
              <i className="ri-chat-3-line"></i>
              문의 및 건의사항
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}